<template>
  <div class="view-type-control">
    <div class="view-type-control__label">Вид каталога:</div>
    <button @click="changeViewtype('grid')"
            :class="['view-type-button', viewtype == 'grid' ? 'current':'']">
      <svg class="view-type-button__icon" preserveAspectRatio="none" width="40" height="40" viewBox="0 0 40 40"
           xmlns="http://www.w3.org/2000/svg">
        <path
            d="m12 18h-10v-17h10zm-8-2h6v-13h-6zm8 23h-10v-17h10zm-8-2h6v-13h-6zm21-19h-10v-17h10zm-8-2h6v-13h-6zm8 23h-10v-17h10zm-8-2h6v-13h-6zm21-19h-10v-17h10zm-8-2h6v-13h-6zm8 23h-10v-17h10zm-8-2h6v-13h-6zm-25-33h4v4h-4zm0 21h4v4h-4zm13-21h4v4h-4zm0 21h4v4h-4zm13-21h4v4h-4zm0 21h4v4h-4z"/>
      </svg>
    </button>
    <button @click="changeViewtype('row')"
            :class="['view-type-button', viewtype == 'row' ? 'current':'']">
      <svg class="view-type-button__icon" preserveAspectRatio="none" width="40" height="40" viewBox="0 0 40 40"
           xmlns="http://www.w3.org/2000/svg">
        <path
            d="m38 11h-36v-10h36zm-34-2h32v-6h-32zm34 16h-36v-10h36zm-34-2h32v-6h-32zm34 16h-36v-10h36zm-34-2h32v-6h-32zm6-33v4h-5v-4zm0 14v4h-5v-4zm0 14v4h-5v-4z"/>
      </svg>
    </button>
    <button
        @click="changeViewtype('table')"
        :class="['view-type-button', viewtype == 'table' ? 'current':'']">
      <svg class="view-type-button__icon" preserveAspectRatio="none" width="40" height="40" viewBox="0 0 40 40"
           xmlns="http://www.w3.org/2000/svg">
        <path
            d="m38 6h-36v-5h36zm-34-2h32v-1h-32zm34 10h-36v-5h36zm-34-2h32v-1h-32zm34 10h-36v-5h36zm-34-2h32v-1h-32zm34 10h-36v-5h36zm-34-2h32v-1h-32zm34 10h-36v-5h36zm-34-2h32v-1h-32z"/>
      </svg>
    </button>
  </div>

</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: "ViewType",
  computed: {
    ...mapGetters({
      viewtype: 'group_info/GET_VIEWTYPE',
    }),
  },
  beforeMount() {
    let result = window.url_helpers.get_viewtype()
    if (result !== null) {
      this.$store.commit("group_info/SET_VIEWTYPE", result);
    }
  },
  methods: {
    changeViewtype(new_viewtype) {
      this.$store.commit("group_info/SET_VIEWTYPE", new_viewtype)
      window.url_helpers.set_viewtype(new_viewtype)
    },
  },
}
</script>

<style scoped>

</style>